module.exports = __webpack_public_path__ + "static/media/ACC-BARANDALES.c6e4dd7a.mp4";